import { translate } from '@utils/i18n';
import { namespace } from '../constants';
export default function generateDefTitle(deficiency, deficiencies) {
    if (!deficiency)
        return '';
    return `${(deficiency === null || deficiency === void 0 ? void 0 : deficiency.isManuallyAdded) ? `${translate('missing', { namespace })} ` : ''}${translate('deficiency', {
        namespace
    })} ${deficiencies.findIndex((def) => def.deficiency_uid === (deficiency === null || deficiency === void 0 ? void 0 : deficiency.deficiency_uid)) + 1}`;
}
